module.exports = __webpack_public_path__ + "img/d7bbe256b419a4e5c0d702e6f8880e00.db78c7b8.png";